import { defineMessages } from "react-intl";

export const messages = defineMessages({
  pageTitle: {
    id: "K1+VJC",
    defaultMessage: "Print Labels",
    description: "print labels workspace, page title",
  },
  whatToPrintTitle: {
    id: "dEtgtt",
    defaultMessage: "What to print",
    description: "print labels workspace, title of the search + queue card",
  },
  searchPlaceholder: {
    id: "NJzgAo",
    defaultMessage: "Name, size or SKU — or scan a barcode",
    description: "print labels workspace, variant search input placeholder",
  },
  searchExactSku: {
    id: "PLCg1R",
    defaultMessage: "Exact SKU",
    description: "print labels workspace, badge on a search result whose SKU equals the query",
  },
  searchEnterAdds: {
    id: "I7VDqY",
    defaultMessage: "Enter adds it",
    description: "print labels workspace, hint next to the exact SKU badge",
  },
  searchResultCount: {
    id: "RA37+h",
    defaultMessage:
      "{variants, plural, one {# variant} other {# variants}} in {products, plural, one {# product} other {# products}}",
    description: "print labels workspace, search results summary",
  },
  searchKeyboardHint: {
    id: "fl7PQB",
    defaultMessage: "↑ ↓ to choose · Enter to add",
    description: "print labels workspace, keyboard hint above search results",
  },
  searchNoResults: {
    id: "rOX0QP",
    defaultMessage: "Nothing found for “{query}”. Try the SKU or a size, e.g. 76mm.",
    description: "print labels workspace, empty search results",
  },
  searchLoading: {
    id: "DSyQxI",
    defaultMessage: "Searching…",
    description: "print labels workspace, search in progress",
  },
  add: {
    id: "UqSwAC",
    defaultMessage: "Add",
    description: "print labels workspace, add a search result to the queue",
  },
  addOneMore: {
    id: "lxpSva",
    defaultMessage: "+1",
    description: "print labels workspace, add one more label of a variant already queued",
  },
  addAllVariants: {
    id: "L93gQK",
    defaultMessage: "{count, plural, one {Add # variant} other {All # variants}}",
    description: "print labels workspace, add every variant of a product",
  },
  inQueue: {
    id: "pE7F7P",
    defaultMessage: "in queue ×{count}",
    description: "print labels workspace, badge on a search result already in the queue",
  },
  pickVariantTitle: {
    id: "yqSO8F",
    defaultMessage: "Pick the variants of {product}",
    description: "print labels workspace, title when arriving from a product page",
  },
  queueTitle: {
    id: "V5CcCR",
    defaultMessage: "Queue",
    description: "print labels workspace, queue card title",
  },
  queueCount: {
    id: "DCJH6Z",
    defaultMessage: "{count, plural, one {# variant} other {# variants}}",
    description: "print labels workspace, number of variants in the queue",
  },
  queueQuantityHint: {
    id: "U9Gpbu",
    defaultMessage: "Quantity = number of labels",
    description: "print labels workspace, hint above the queue",
  },
  emptyQueue: {
    id: "8qsJbj",
    defaultMessage: "Search above, or scan the barcode on a label.",
    description: "print labels workspace, empty queue",
  },
  clearQueue: {
    id: "u0rO/U",
    defaultMessage: "Clear",
    description: "print labels workspace, empty the queue",
  },
  remove: {
    id: "mDix+X",
    defaultMessage: "Remove {sku}",
    description: "print labels workspace, remove a variant from the queue (icon button label)",
  },
  decrease: {
    id: "eWhbYD",
    defaultMessage: "One label fewer",
    description: "print labels workspace, quantity stepper minus button",
  },
  increase: {
    id: "xkDkpa",
    defaultMessage: "One label more",
    description: "print labels workspace, quantity stepper plus button",
  },
  quantityLabel: {
    id: "L8l5qn",
    defaultMessage: "Number of labels",
    description: "print labels workspace, quantity input label",
  },
  productLabel: {
    id: "7/1bvO",
    defaultMessage: "Product label",
    description: "print labels workspace, name shown for a product without variants",
  },
  added: {
    id: "Qrh/MD",
    defaultMessage: "{sku} added",
    description: "print labels workspace, notification after adding a variant",
  },
  savedQueuesButton: {
    id: "O0PwvC",
    defaultMessage: "{count, plural, =0 {Saved queues} other {Saved queues (#)}}",
    description: "print labels workspace, toggles the list of saved queues",
  },
  savedQueuesLoading: {
    id: "7cVXRo",
    defaultMessage: "Loading saved queues…",
    description: "print labels workspace, saved queues list while loading",
  },
  savedQueuesEmpty: {
    id: "uydLOF",
    defaultMessage: "No saved queues yet. Build a queue below and save it to reuse it.",
    description: "print labels workspace, empty saved queues list",
  },
  savedQueueSummary: {
    id: "H5S7nz",
    defaultMessage:
      "{labels, plural, one {# label} other {# labels}} · {variants, plural, one {# variant} other {# variants}}",
    description: "print labels workspace, saved queue row summary",
  },
  savedQueueOpen: {
    id: "RbBp0D",
    defaultMessage: "Open",
    description: "print labels workspace, replace the queue with a saved queue",
  },
  savedQueueAppend: {
    id: "N9lqGP",
    defaultMessage: "Add to queue",
    description: "print labels workspace, add a saved queue's items to the current queue",
  },
  savedQueueAppendHint: {
    id: "tlcMs5",
    defaultMessage: "Add these variants to the current queue instead of replacing it",
    description: "print labels workspace, tooltip of the add-to-queue button",
  },
  savedQueueDelete: {
    id: "+cC+Nl",
    defaultMessage: "Delete",
    description: "print labels workspace, delete a saved queue",
  },
  savedQueueDeleteNamed: {
    id: "pjS7W4",
    defaultMessage: "Delete {name}",
    description: "print labels workspace, delete saved queue icon button label",
  },
  savedQueueDeleteConfirm: {
    id: "h7ZiiF",
    defaultMessage: "Delete “{name}” for everyone?",
    description: "print labels workspace, inline delete confirmation for a saved queue",
  },
  cancel: {
    id: "r46XfK",
    defaultMessage: "Cancel",
    description: "print labels workspace, cancel button",
  },
  saveQueue: {
    id: "KfXZC5",
    defaultMessage: "Save queue",
    description: "print labels workspace, opens the save-queue dialog",
  },
  saveQueueTitle: {
    id: "y06i/U",
    defaultMessage: "Save queue",
    description: "print labels workspace, save-queue dialog title",
  },
  saveQueueHint: {
    id: "iF8je8",
    defaultMessage: "Saved queues are shared with everyone who prints labels.",
    description: "print labels workspace, save-queue dialog explanation",
  },
  queueNameLabel: {
    id: "GQs1Yt",
    defaultMessage: "Queue name",
    description: "print labels workspace, save-queue dialog name input",
  },
  queueNameRequired: {
    id: "VWQ4lu",
    defaultMessage: "Give the queue a name",
    description: "print labels workspace, save-queue dialog validation",
  },
  saveQueueOverwrite: {
    id: "rjv4aO",
    defaultMessage: "Replaces your saved queue “{name}”.",
    description:
      "print labels workspace, save-queue dialog when the name is one of the user's queues",
  },
  saveQueueTakenByOther: {
    id: "rdXaCq",
    defaultMessage: "“{name}” was saved by someone else. Choose another name.",
    description: "print labels workspace, save-queue dialog when another user owns the name",
  },
  queueSaved: {
    id: "P8wv5M",
    defaultMessage: "Queue “{name}” saved",
    description: "print labels workspace, notification after saving a queue",
  },
  queueDeleted: {
    id: "dDiq8P",
    defaultMessage: "Queue “{name}” deleted",
    description: "print labels workspace, notification after deleting a queue",
  },
  queueLoaded: {
    id: "xNCxZQ",
    defaultMessage: "Queue “{name}” loaded",
    description: "print labels workspace, notification after opening a saved queue",
  },
  queueMissingItems: {
    id: "nH8Z2x",
    defaultMessage:
      "{count, plural, one {# variant} other {# variants}} of this queue no longer exist and were left out",
    description:
      "print labels workspace, notification when a saved queue references deleted variants",
  },
  queueSaveFailed: {
    id: "XQ6mxK",
    defaultMessage: "Could not save the queue",
    description: "print labels workspace, error notification",
  },
  loadedQueueName: {
    id: "m+LBYz",
    defaultMessage: "“{name}”",
    description:
      "print labels workspace, name of the saved queue currently loaded, next to the queue title",
  },
  queueLoadFailed: {
    id: "N+wDuZ",
    defaultMessage: "Could not open the saved queue",
    description: "print labels workspace, error notification when a saved queue can't be loaded",
  },
});
